module.exports = __webpack_public_path__ + "img/安全可靠服务-中层.9f0b16bd.png";